'use strict';

module.exports = '3.8.2';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 27
// module chunks = 0